<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">Requests List</h3>
            </div>
            <v-card>
              <v-card-title
                :class="
                  $vuetify.breakpoint.mdAndUp ? 'col-6 float-right' : 'col-12'
                "
              >
                <v-text-field
                  class="search-text-field"
                  v-model="search"
                  append-icon="search"
                  label="Search by Email, First Name, Last Name"
                  single-line
                  hide-details
                  v-debounce:1s="searchFilter"
                  :debounce-events="['click', 'keydown']"
                ></v-text-field>
              </v-card-title>
              <v-data-table
                class="float-left width-100"
                :headers="headers"
                :items="users"
                :loading="loading"
                loading-text="Loading... Please wait"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
              <template v-slot:item.usersData.firstName="{ item }">
                <div v-if="item.usersData">
                  {{ item.usersData.firstName }} {{ item.usersData.lastName }}
                </div>
              </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <approve-request
                    moduleName="Approve"
                    :Detail="item"
                    :isStatus="true"
                    class="ma-0 float-left"
                    @RequestHandled="RequestHandled"
                  ></approve-request>
                  <decline-request
                    moduleName="Reject"
                    :Detail="item"
                    :isStatus="false"
                    class="ma-0"
                    @RequestHandled="RequestHandled"
                  ></decline-request>
                </template>
                <template v-slot:[`item.isActive`]="{ item }">{{
                  item.isActive ? "Approved" : "Pending"
                }}</template>
              </v-data-table>
              <v-card-actions class="justify-end pt-2 float-left width-100">
                <v-pagination
                  circle
                  v-model="page"
                  :length="pageCount"
                  :total-visible="7"
                ></v-pagination>
              </v-card-actions>
            </v-card>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import { CommunityService } from "@/services";
import PermissionDialog from "./PermissionDialog";

export default {
  name: "UserRequestList",
  components: {
    CommonSection,
    ApproveRequest: PermissionDialog,
    DeclineRequest: PermissionDialog,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    loading: true,
    itemsPerPage: 50,
    search: "",
    users: [],
    headers: [
      {
        text: "Email",
        align: "start",
        value: "usersData.email",
      },
      { text: "User Name", value: "usersData.firstName" },
      // { text: "Last Name", value: "usersData.lastName" },
      { text: "Role", value: "roles.name" },
      { text: "Community", value: "channelData.title" },
      { text: "Request Reason", value: "requestReason" },
      // { text: "Status", value: "isActive", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  watch: {
    page() {
      this.initialize();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      const params = {
        limit: parseInt(this.itemsPerPage),
        skip:
          parseInt(this.page) * parseInt(this.itemsPerPage) -
          parseInt(this.itemsPerPage),
        search: this.search,
      };

      const requestList = await CommunityService.RequestList(params);

      if (requestList.data.data.length > 0) {
        this.pageCount = Math.ceil(
          requestList.data.option[0].count / this.itemsPerPage
        );
        this.users = requestList.data.data;
        this.loading = false;
      } else {
        if (this.page !== 1) {
          this.page--;
        }
        this.loading = false;
        this.users = [];
      }
    },
    getColor(isActive) {
      if (isActive) return "green";
      else return "orange";
    },
    searchFilter() {
      this.page = 1;
      this.initialize();
    },
    RequestHandled() {
      this.initialize();
    },
  },
};
</script>